// Constants
import { BUDGETING_BASICS_MODULES } from './budgeting-basics';

// Types
import { WorkshopType } from '../../types';
import { WorkshopModule } from '../types';

/**
 * Every workshop type's module list. Adding a workshop type means adding its
 * content file and one entry here — the modules UI itself is type-agnostic.
 * Because this is a full `Record`, a new `WorkshopType` value won't compile until
 * its content is registered.
 */
const MODULES_BY_WORKSHOP_TYPE: Record<WorkshopType, WorkshopModule[]> = {
  BUDGETING_BASICS: BUDGETING_BASICS_MODULES
};

export const getWorkshopModules = (type: WorkshopType): WorkshopModule[] =>
  MODULES_BY_WORKSHOP_TYPE[type] ?? [];
